"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  label: _propTypes["default"].string,
  ctas: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    link: _propTypes["default"].string,
    linkOriginal: _propTypes["default"].string,
    ctaAlignment: _propTypes["default"].string,
    openNewTab: _propTypes["default"].bool,
    icon: _propTypes["default"].string
  }))
});
var _default = exports["default"] = PROP_TYPES;